import clsx from 'clsx';

import { Icon } from '@gitbook/spine-icons';

import { useSegmentedControlContext } from '../SegmentedControlContext';

export type CardCheckProps = {
    size?: number;
    className?: string;
    kind?: 'checkbox' | 'radio';
};

/**
 * Represents the checkmark of a card, indicating the selection state.
 */
export function CardCheck(props: CardCheckProps) {
    const { size = 16, className, kind = 'radio' } = props;
    const state = useSegmentedControlContext();

    return (
        <div
            className={clsx(
                'inline-flex shrink-0 items-center justify-center border border-neutral-subtle p-0.5 transition-shadow duration-0 motion-safe:duration-300',
                state.isSelected && 'border-primary-subtle bg-primary-solid',
                kind === 'radio' ? 'rounded-full' : 'rounded-lg',
                className
            )}
        >
            <Icon.AnimatedCheck
                size={size}
                isSelected={state.isSelected}
                className="shrink-0 text-white"
            />
        </div>
    );
}
